import React, { useState } from "react";
import "./ChangePassword.css";
import { Button, Form, Modal, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { ChangePasswordPost } from "../../../../utils/apis/Login/index";
import { HTTPS } from "../../../../utils/common";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ModalSave from "../Successfull_Modal/ModelSave";

function ChangePassword(props) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      old_password: "",
      password: "",
      confirm_password: "",
    },
  });

  const password = watch("password");

  // Success modal state
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("old_password", data.old_password);
      sendData.append("password", data.password);
      sendData.append("confirm_password", data.confirm_password);

      console.log("Change Password Data:", data);

      const response = await ChangePasswordPost(sendData);

      console.log("Change Password Response:", response);

      if (response?.data?.code === HTTPS.OK.code) {
        // Close change password modal
        props.onHide();

        // Reset form
        reset();

        // Show success modal
        setShowModal({
          code: response?.data?.code || HTTPS.CREATED.code,
          message: response?.data?.message || "Password changed successfully!",
        });
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.onHide();
          reset();
        }, 2000);
      } else {
        setError("root", {
          type: "manual",
          message:
            response?.data?.errors ||
            response?.data?.message ||
            "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Change Password Error:", error);

      setError("root", {
        type: "manual",
        message:
          error?.response?.data?.errors ||
          error?.response?.data?.message ||
          "An error occurred",
      });
    }
  };

  const handleClose = () => {
    reset();
    props.onHide();
  };

  // Close success modal
  const handleSuccessClose = () => {
    setShowModal({
      code: 0,
      message: "",
    });
  };

  return (
    <div className="Successfull_Modal_sec">
      {/* Change Password Modal */}
      <Modal
        className="Successfull_Modal"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* API Error */}
            {errors.root?.message && (
              <div className="alert alert-danger">{errors.root.message}</div>
            )}

            {/* Old Password */}
            <Form.Group className="mb-3">
              <Form.Label>Old Password</Form.Label>

              <InputGroup>
                <Form.Control
                  type={showOldPassword ? "text" : "password"}
                  placeholder="Enter old password"
                  {...register("old_password", {
                    required: "Old password is required",
                  })}
                  isInvalid={!!errors.old_password}
                />

                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={() => setShowOldPassword((prev) => !prev)}>
                  {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>

                <Form.Control.Feedback type="invalid">
                  {errors.old_password?.message}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* New Password */}
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>

              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  {...register("password", {
                    required: "New password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  })}
                  isInvalid={!!errors.password}
                />

                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>

                <Form.Control.Feedback type="invalid">
                  {errors.password?.message}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>

              <InputGroup>
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm new password"
                  {...register("confirm_password", {
                    required: "Confirm password is required",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  })}
                  isInvalid={!!errors.confirm_password}
                />

                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>

                <Form.Control.Feedback type="invalid">
                  {errors.confirm_password?.message}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                variant="secondary"
                type="button"
                onClick={handleClose}
                disabled={isSubmitting}>
                Cancel
              </Button>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Changing..." : "Change Password"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Success Modal */}
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />
    </div>
  );
}

export default ChangePassword;
